import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IUserMast, WorkFrom } from "../../models/UserMast";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IModel } from "./ExternalUserMast";
import { ILogin, IPermissionProps } from "../../models/Login";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { AttendanceHistoryTable } from "../attendanceMark/Table";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "./Filter";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

export interface IUserFilter {
    company: number | null,
    branch: number | null,
    status: boolean | null,
    temp_Status: boolean | null,
    work_From: string | null,
    department: number | null,
    user_Type: number | null,
}

export const EmptyFilter: IUserFilter = {
    company: null,
    branch: null,
    status: null,
    temp_Status: null,
    work_From: null,
    department: null,
    user_Type: null
};

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IUserMast>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [attendanceTable, setAttendanceTable] = useState({ user_id: 0, open: false } as { user_id: number, open: boolean });
    const [filters, setFilters] = useState<IUserFilter>(EmptyFilter);
    const [loading, setLoading] = useState(false);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const getTableDataCount = async () => {
        const response = await Fetch("ExternalUser_Mast/count", "GET", null, `filter=${globalFilter}&filters=${JSON.stringify(filters)}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    useEffect(() => {
        loadTableData();
        getTableDataCount();
    }, [globalFilter, lazyParams, props.reload, filters]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        setLoading(true);
        const response = await Fetch("ExternalUser_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filters=${JSON.stringify(filters)}&filter=${globalFilter}${_roles.includes(4) ? "&recruiterHead=1" : ""}`, props.toast);
        if (response) {
            const data: Array<IUserMast> = await response.json();
            setTableData({ tableData: data, loading: false });
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    const openEdit = (rowDatauser: any) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Users</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const toggleVal = async (login_id: number, toggle_type: number) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("ExternalUser_Mast/toggle", "PUT", null, `login_id=${login_id}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            props.setReload(!props.reload);
            let message: string = toggle_type === 1 ? "User Status Changed" : toggle_type === 2 ? "Temp Status Changed" : "Work From Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const user_Status = (rowData: IUserMast) => {
        return (
            <span className="cursor-pointer text-cyan-700" onClick={() => { if (rowData.login_ID) toggleVal(rowData.login_ID, 1) }}>{rowData.user_Status ? "Inactive" : "Active"}</span>
        );
    };
    const user_TStatus = (rowData: IUserMast) => {
        return (
            <span className="cursor-pointer text-cyan-700" onClick={() => { if (rowData.login_ID) toggleVal(rowData.login_ID, 2) }}>{rowData.temp_Inactive ? "Inactive" : "Active"}</span>
        );
    };
    const workFrom = (rowData: IUserMast) => {
        return (
            <span className="cursor-pointer text-cyan-700" onClick={() => { if (rowData.login_ID) toggleVal(rowData.login_ID, 3) }}>{rowData.workFrom ? WorkFrom[rowData.workFrom] : "Not Specified"}</span>
        );
    };

    const actionBodyTemplate = (rowData: IUserMast) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };



    const onHideHistoryTable = () => {
        setAttendanceTable({ user_id: 0, open: false });
    }

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IUserFilter) => setFilters(filters)} loading={loading} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="user_Name" header="User_Name" sortable />
                <Column field="login_Name" header="Login_Name" sortable />
                <Column field="user_EmailID" header="EmailID" sortable />
                <Column field="login_Password" header="Login Password" sortable />
                <Column field="user_Status" header="Status" body={user_Status} sortable />
                <Column field="temp_Inactive" header="Temp Status" body={user_TStatus} sortable />
                <Column field="workFrom" header="Work From" body={workFrom} />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <Dialog visible={attendanceTable.open} style={{ width: '80vw' }} header="history of User" modal className="p-fluid" onHide={onHideHistoryTable} >
                <AttendanceHistoryTable user_ID={attendanceTable.user_id} />
            </Dialog>
        </>
    );
}
